export { pmaSvg, growSvg }

var pmaSvg = `<svg width="13" height="12" viewBox="0 0 13 12" fill="currentColor" display="block" xmlns="http://www.w3.org/2000/svg">
<path d="M0 7.82389H2.49952V12H0V7.82389ZM4.50801 5.47068H7.00754V12H4.50801V5.47068ZM13 3.11746H11.5166V12H9.01809V3.11746H7.53468L10.2684 0L13 3.11746Z"/>
</svg>
`
const growSvg = `<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 496.39294 500">
  <defs>
    <style>
      .st0 {
        fill: #007dba;
      }

      .st1 {
        fill: #004d72;
      }

      .st2 {
        fill: #077dba;
      }
    </style>
  </defs>
  <path class="st2" d="M383.36508,137.05701c-35.16223-13.54272-85.77054-20.23339-139.48215-13.75995-74.79735,9.0202-123.27887,69.57141-112.69876,143.78534,9.98428,70.09277,68.11288,119.64185,139.02286,111.05402,65.26099-7.86166,97.46268-54.44397,93.84323-89.69724-.15103-1.40891-.29791-2.8157-.44791-4.22668-34.71536,3.67429-69.40799,7.61337-104.07785,11.81522-4.37045-36.06219-8.74194-72.11818-13.1124-108.17831,78.31647-9.49811,156.755-17.6618,235.27631-24.49522,6.09897,18.64452,11.47592,46.58646,13.71341,72.67885,10.11566,125.15945-57.68896,243.22894-214.2619,261.94794C142.94562,514.78217,26.30984,425.20078,3.4159,286.10345-19.48528,147.32265,74.6393,22.56662,229.49612,3.86418c50.81726-6.13829,106.27704-4.99214,140.81241,3.64325,4.35287,43.18526,8.70367,86.36638,13.05655,129.54958Z"/>
  <g>
    <g>
      <path class="st0" d="M363.60883,284.21793c.15018,1.41098.29688,2.81757.44791,4.22678,3.61996,35.25363-28.58255,81.83691-93.84497,89.69852-70.91066,8.58804-129.04054-40.96167-139.02557-111.05597-10.57963-74.21542,37.90225-134.76735,112.70093-143.78802,53.71277-6.47333,104.32156.21741,139.48483,13.76041-4.35251-43.18421-8.70416-86.36624-13.05667-129.55176-34.53638-8.63606-89.99713-9.78203-140.81461-3.64354C74.64103,22.56708-19.48596,147.32539,3.41605,286.10867c22.48727,136.62537,135.41346,225.47037,270.3764,212.66824,123.52328-72.78262,89.81638-214.55896,89.81638-214.55896v-.00003Z"/>
      <path class="st1" d="M495.41107,236.03728c-2.23782-26.09283-7.6145-54.03494-13.71414-72.68004-78.52255,6.8335-156.96213,14.99719-235.28036,24.4959,4.37085,36.06084,8.7417,72.11732,13.11255,108.17989,34.67084-4.2019,69.36346-8.14099,104.07971-11.81509,0,0,33.70691,141.77634-89.81638,214.55899,2.44473-.23181,4.89386-.48764,7.35257-.78668,156.5762-18.7193,224.38116-136.79083,214.26605-261.95294v-.00002Z"/>
    </g>
    <path class="st2" d="M360.9256,271.03961"/>
  </g>
</svg>`